import ChallengeLeagueTags from "@Enums/ChallengeLeagueTags";
import League from "@Enums/Leagues";
import { Division, League as GlobalLeague } from "@Globals/types";
import { Theme } from "@mui/material";

const getLeagueFromTag = (tag: ChallengeLeagueTags) => {
  const leagueMap = {
    [ChallengeLeagueTags.BOOTCAMP]: League.BOOTCAMP,
    [ChallengeLeagueTags.BRONZE]: League.BRONZE,
    [ChallengeLeagueTags.SILVER]: League.SILVER,
    [ChallengeLeagueTags.GOLD]: League.GOLD,
    [ChallengeLeagueTags.CHAMPIONS]: League.CHAMPIONS,
  };

  return leagueMap[tag as keyof typeof leagueMap];
};

const getLeagueColor = (leagueName: League | ChallengeLeagueTags, theme: Theme) => {
  const gradients = {
    [League.BOOTCAMP]: theme.palette.dsSuccess.v400,
    [League.BRONZE]: theme.palette.dsSecondaryBrown.v300,
    [League.SILVER]: theme.palette.dsNeutral.v200,
    [League.GOLD]: theme.palette.dsSecondaryYellow.v400,
    [League.CHAMPIONS]: theme.palette.dsPrimary.v400,
  };

  return gradients[leagueName as keyof typeof gradients] || theme.palette.dsSurface.v100;
};

const getNextLeagueText = (i18n: any,division?: Division | null, nextLeague?: GlobalLeague | null) => {
  if (!division || !nextLeague) return null;
  const divisionsLeft = Number(division.name) - 1;

  return divisionsLeft > 1
    ? i18n("progress.career.status.progress.base", { divisions: divisionsLeft, league: i18n(`league.${nextLeague.name}.short`) })
    : divisionsLeft === 1
    ? i18n("progress.career.status.progress.last", { divisions: divisionsLeft, league: i18n(`league.${nextLeague.name}.short`) })
    : i18n("progress.career.status.progress.last", { divisions: divisionsLeft, league: i18n(`league.${nextLeague.name}.short`) });
};

export { getLeagueColor, getLeagueFromTag, getNextLeagueText };
